import { render, staticRenderFns } from "./Endpage.vue?vue&type=template&id=bee43ba6&scoped=true"
import script from "./Endpage.vue?vue&type=script&lang=js"
export * from "./Endpage.vue?vue&type=script&lang=js"
import style0 from "./Endpage.vue?vue&type=style&index=0&id=bee43ba6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee43ba6",
  null
  
)

export default component.exports